export default __webpack_public_path__ + "static/char-56-af531a278f2cb57fd056366322281067.webp";